import { useState } from 'react';
import { Button, ButtonTheme } from '@apply/components';
import { SelectDrawUserModal } from '../../../../../SelectDrawUserModal/SelectDrawUserModal';

export interface ChangeUserButtonProps {
    propertyId: number;
    userId: string;
    onRefresh: () => void;
}

export const ChangeUserButton: React.FC<ChangeUserButtonProps> = ({ propertyId, userId, onRefresh }) => {
    const [linkGCUserToPropertyOpen, set_linkGCUserToPropertyOpen] = useState<boolean>(false);

    const onCloseLinkGCUserToProperty = () => {
        set_linkGCUserToPropertyOpen(false);
    };

    const onOpenLinkGCUserToProperty = () => {
        set_linkGCUserToPropertyOpen(true);
    };

    if (!propertyId) {
        return;
    }

    return (
        <>
            <Button
                id={`linkUserButton${propertyId}`}
                theme={ButtonTheme.LinkBlue}
                height='20px'
                handleClick={onOpenLinkGCUserToProperty}
            >
                Change
            </Button>
            <SelectDrawUserModal
                propertyId={propertyId}
                userId={userId}
                isOpen={linkGCUserToPropertyOpen}
                isEdit={true}
                onClose={onCloseLinkGCUserToProperty}
                onSaved={onRefresh}
            />
        </>
    );
};
